module.exports = __webpack_public_path__ + "static/media/portfolio2.8f7132c7.jpg";